export const getImageSize = (file: string): { width: number; height: number } => {
  const dimensions = file.split('/')[5].split('x');
  return {
    width: parseInt(dimensions[0], 10),
    height: parseInt(dimensions[1], 10),
  };
};
